<template>
  <div class="menuList">
    <div class="banner">
      <img src="../../../static/icon/bannner.png" alt="">
      <div class="info">
        <p class="title_info">智慧供热服务大厅</p>
        <p class="text_info"><span v-if="name">{{name}} - </span>{{code}}</p>
      </div>
    </div>
    <div class="cardItem" v-for="(item, ind) in menuList" v-if="getTitle(item.list)" :key="ind">
      <h2 class="oneTitle">{{item.title}}</h2>
      <div class="menuIcon">
        <div :key="index" @click="toPage(itemChild)" v-if="getFlag(itemChild.roleFlag)" :class="getFlag(itemChild.roleFlag)?'menu_item':'menu_item notCheck'" v-for="(itemChild, index) in item.list">
          <img :src="itemChild.icon" class="img_menu_item"/>
          <span>{{itemChild.title}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getBindReli, findRoles, isCustomer, validPzSlsx} from '@/api'

  export default {
    data() {
      return {
        name: '',
        address: '',
        menuList: [
          {
            title: '我要缴费',
            list: [
              {
                icon: require('../../../static/icon/gnjf.png'),
                title: '供热缴费',
                roleFlag: 'jf',
                path: 'payment',
                jx: '缴费'
              },
              {
                icon: require('../../../static/icon/jfcx.png'),
                title: '缴费记录',
                roleFlag: 'jfjl',
                path: 'payList',
              },
              {
                icon: require('../../../static/icon/dzfp.png'),
                title: '电子发票',
                roleFlag: 'dzfp',
                path: 'dzfp',
                jx: '开票'
              },
              {
                icon: require('../../../static/icon/tfsq.png'),
                title: '减免申请',
                roleFlag: 'jmsq'
              },
              {
                icon: require('../../../static/icon/gnjf.png'),
                title: '退费申请',
                roleFlag: 'tfsq'
              },
              {
                icon: require('../../../static/icon/jffs.png'),
                title: '计费方式',
                roleFlag: 'jffs'
              }

            ]
          },
          {
            title: '办理业务',
            list: [
              {
                icon: require('../../../static/icon/gmgh.png'),
                title: '更名过户',
                roleFlag: 'gmgh',
                path: 'gmList',
                jx: '更名'
              },
              {
                icon: require('../../../static/icon/bltg.png'),
                title: '申请停热',
                roleFlag: 'tg',
                path: 'tgList',
                jx: '停供'
              },
              {
                icon: require('../../../static/icon/blfg.png'),
                title: '申请复供',
                roleFlag: 'fg',
                path: 'fgList',
                jx: '复供'
              },
              {
                icon: require('../../../static/icon/mjbg.png'),
                title: '面积变更',
                roleFlag: 'mjbg',
                path:'/mjbgList',
                jx: '面积变更'
              },
              {
                icon: require('../../../static/icon/rwsh.png'),
                title: '入网申请',
                roleFlag: 'rwsh',
                path:'/rwsh',
              },
              {
                icon: require('../../../static/icon/cwsq.png'),
                title: '测温申请',
                roleFlag: 'cwsq',
                path:'baoxiu'
              },
              {
                icon: require('../../../static/icon/gnbx.png'),
                title: '故障报修',
                roleFlag: 'bx',
                path: 'baoxiuList',
              },
              {
                icon: require('../../../static/icon/yyfw.png'),
                title: '预约服务',
                roleFlag: 'yyfw',
                path: 'baoxiu',
              },
              {
                icon: require('../../../static/icon/tsjy.png'),
                title: '投诉建议',
                roleFlag: 'tsjy',
                path: 'baoxiu',
              },
              {
                icon: require('../../../static/icon/yhcw.png'),
                title: '用户测温',
                roleFlag: 'yhcw',
                path: 'yhcw',
              },

            ]
          },
          {
            title: '我是房主',
            list: [
              {
                icon: require('../../../static/icon/yhbm.png'),
                title: '用户编码',
                roleFlag: 'ewm',
                path: 'qRcode',
              },
              {
                icon: require('../../../static/icon/fcxx.png'),
                title: '房产信息',
                roleFlag: 'fcxx'
              },
              {
                icon: require('../../../static/icon/xxbg.png'),
                title: '信息变更',
                roleFlag: 'xxbg'
              },
              {
                icon: require('../../../static/icon/szmm.png'),
                title: '设置密码',
                roleFlag: 'password',
                path: 'setPassword'
              },
              {
                icon: require('../../../static/icon/fcxx.png'),
                title: '我是房主',
                roleFlag: 'wsfz',
                path: 'wsfz'
              }
            ]
          },
          {
            title: '信息查询',
            list: [
              {
                icon: require('../../../static/icon/fwwd.png'),
                title: '服务网点',
                roleFlag: 'fwwd',
                path: 'fuwuwangdian'
              },
              {
                icon: require('../../../static/icon/hzyh.png'),
                title: '合作银行',
                roleFlag: 'hzyh',
                path: 'hezuoyinhang'
              },
              {
                icon: require('../../../static/icon/zcfg.png'),
                title: '政策法规',
                roleFlag: 'zcfg',
                path: 'zhengcefagui',
              },
              {
                icon: require('../../../static/icon/khcx.png'),
                title: '卡号查询',
                roleFlag: 'khcx'
              },
              {
                icon: require('../../../static/icon/bszn.png'),
                title: '业务指南',
                roleFlag: 'bszn',
                path:'banshizhinan'
              },
              {
                icon: require('../../../static/icon/fybz.png'),
                title: '费用标准',
                roleFlag: 'fybz',
                path:'feiyongbiaozhun'
              },
              {
                icon: require('../../../static/icon/jfzn.png'),
                title: '用热常识',
                roleFlag: 'jfzn',
                path:'jiaofeizhinan'
              },
              {
                icon: require('../../../static/icon/cjwt.png'),
                title: '热点问题',
                roleFlag: 'cjwt',
                path:'changjianwenti'
              },

            ]
          }
        ],
        code: this.$route.query.code,
        roles: sessionStorage.getItem('roles')
      }
    },
    created() {


    },
    mounted() {
      if(sessionStorage.getItem('companyCode') == 'huilian') {
        this.getBindReli()
      }
      this.setRoles()
    },
    methods: {
      toPage(item) {
        if(item.path) {
          if(item.validate) {
            isCustomer({
              code: this.$route.query.code,
            }).then(res=>{
              if(res.code=='0000') {
                this.$router.push({
                  path: item.path,
                  query: this.$route.query
                })
              }
            })
          } else {
            if((!sessionStorage.getItem(item.jx))&&item.jx) {
              validPzSlsx({type: item.jx}).then(res=>{
                sessionStorage.setItem(item.jx,res.data)
              })
            }
            let query = this.$route.query
            if(item.title=='测温申请') {
              query.type = 2
            }
            if(item.title=='投诉建议') {
              query.type = 3
            }
            this.$router.push({
              path: item.path,
              query: query
            })
          }
        } else {
          this.$toast('建设中')
        }

      },
      getTitle(list) {
        let  roles = JSON.parse(sessionStorage.getItem('roles') || this.roles)
        let returnValue = false
          list.map(v=>{
           if(roles[v.roleFlag]) {
             returnValue = true
           }
          })
        return returnValue
      },
      getFlag(key) {
        let  roles = sessionStorage.getItem('roles') || this.roles
        if(roles){
          roles = JSON.parse(roles)
          return roles[key]
        }
      },
      setRoles() {
        findRoles({companyCode: sessionStorage.getItem('companyCode')}).then(res=>{
          sessionStorage.setItem('roles',JSON.stringify(res.data))
          this.roles = JSON.stringify(res.data)
        })
      },
      /**
       * 获取热力公司
       */
     getBindReli() {
        getBindReli(sessionStorage.getItem('thirdId')).then(res=> {
            if(!res){
                this.$router.push('/bindComponey')
            } else {
                this.name = res.data.companyName
            }
        })
    },
    }
};
</script>

<style  scoped>
 .menuList{
   min-height: 91%;
    /* background: #fff; */
    /* height: 100%; */
 }
 .cardItem{
   background: #fff;
   width: calc(100% - 40px);
   margin: 10px;
   border-radius: 8px;
   padding: 14px 10px;

 }
 .oneTitle{
    font-size: 16px;
   font-weight: bold;
   margin-left: 5px;
   margin-bottom: 14px;
 }
 .menuIcon{
   display: flex;
   flex-wrap: wrap;
   justify-content: flex-start;
 }
.cell_item {
  height: 40px;
  line-height: 40px;
  display: flex;
  background: #fff;
  justify-content: space-between;
  padding: 0 3%;
  border-bottom: 1px solid #eee8e8;
}

.menu {
  display: flex;
  justify-content: flex-start;
  background: #ffffff;
  flex-wrap: wrap;
}

.menu_item {
  width: 20%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;

  padding-bottom: 14px;
  font-size: 14px;

}
.menu_item>img{
  width: 48px;
  margin-bottom: 8px;
}

.menu_icon {
  font-size: 25px;
}

.banner {
  text-align: center;
  position: relative;
}

.banner img {
  width: 100%;
  height: auto;
}
.info{
  position: absolute;
  top: 33%;
  left: 5%;
  color: #f1f1f1;
  text-align: left;
}
.info>.title_info{
  font-weight: bold;
  font-size: 24px;
  margin-bottom: 14px;
}
.info>.text_info{
  font-size: 16px;
}
.img_menu_item {
  width: 50px;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/view/menuList/index.vue